import { AdminFeedbackEntry } from '~src/hooks/api/adminFeedback/types';
import {NameContainer, FeedbackItemContainer} from './FeedbackItem.styled';
import AvatarBox from '~src/shared/avatarBox/AvatarBox';
import {FaRegCalendar, FaRegCalendarCheck} from 'react-icons/fa';
import { FaRegCalendarMinus } from 'react-icons/fa';
import {useDateFormatter} from "~src/services/hooks/useDateFormatter";
import styled from "styled-components";

const HalfContainer = styled.div`
  width: 50%
`;
const IconSpacer = styled.div`
  display: inline-block;
  margin-right: 5px;
`

interface FeedbackItemProps {
  data: AdminFeedbackEntry;
}

const FeedbackItem = ({ data }: FeedbackItemProps) => {
  // const { t } = useTranslation();
  const dateFormatter = useDateFormatter();

  let employeeStatus = <div><IconSpacer><FaRegCalendar size={16} fill="#ccc" /></IconSpacer>Status: Open</div>
  if (data.managerFinishedAt) {
    employeeStatus = <div><IconSpacer><FaRegCalendarMinus size={16} fill="#fd7e14" /></IconSpacer>Status: Open</div>
  }
  if (data.userFinishedAt) {
    employeeStatus = <div><IconSpacer><FaRegCalendarCheck size={16} fill="#28a745" /></IconSpacer> Confirmed: {dateFormatter(data.userFinishedAt)}</div>
  }

  /*
  t('admin.feedback.user.completion.completed', {
    name: data.user.meta.firstname,
    date: dateFormatter(data.userFinishedAt || undefined),
  })
  t('admin.feedback.user.completion.open', { name: data.user.meta.firstname })}
  */

  let managerStatus = <div><IconSpacer><FaRegCalendarMinus size={16} fill="#fd7e14" /></IconSpacer>Status: Open</div>
  if (data.managerFinishedAt) {
    managerStatus = <div><IconSpacer><FaRegCalendarCheck size={16} fill="#28a745" /></IconSpacer>Completed: {dateFormatter(data.managerFinishedAt)}</div>
  }

  if (!data.user || !data.user.meta) {
    console.warn('empty data.user.meta, this should never be!', data);
    return;
  }

  return (
    <FeedbackItemContainer>
      <AvatarBox size={32} url={data.user.image_url} name={data.user.meta.name} />
      <HalfContainer>
        <NameContainer>{data.user.meta.name}</NameContainer>
        {employeeStatus}
      </HalfContainer>
      <HalfContainer>
        <NameContainer>Manager: {data.manager?.meta?.name}</NameContainer>
        {managerStatus}
      </HalfContainer>
    </FeedbackItemContainer>
  );
};

export default FeedbackItem;
